// Import React, hooks, and components
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Import user-specific components
import ClientChatBox from '../pages/Public/ClientChatBox/ClientChatBox';
import Navbar from '../pages/Public/Navbar/Navbar';
import Footer from '../pages/Public/Footer/Footer';
import OnboardingNotification from '../components/OnboardingNotification';

// Define the UserLayout component
const UserLayout = () => {
  // Hook to access current route location
  const location = useLocation();
  // Retrieve user and onboarding status from Redux store
  const user = useSelector((state) => state.auth.user);
  const onboardingCompleted = useSelector((state) => state.auth.onboardingCompleted);

  // Determine if navbar should be hidden (on home page)
  const hideNavbar = location.pathname === "/";

  return (
    // Main container for user-facing pages
    <div>
      {/* Conditionally render Navbar based on route */}
      {!hideNavbar && <Navbar />}
      {/* Main content area for rendering nested routes */}
      <main>
        <Outlet />
      </main>
      {/* Render ClientChatBox if user is authenticated */}
      {user && <ClientChatBox />}
      {/* Render OnboardingNotification if user is authenticated and onboarding is incomplete */}
      {user && !onboardingCompleted && <OnboardingNotification />}
      {/* Render Footer component */}
      <Footer />
    </div>
  );
};

// Export the UserLayout component
export default UserLayout;